export default "__VITE_ASSET__IUiqn0Hz__"